/* DeluxeHomeArt – produktside-forbedringer (okt. 2026).
   1) Flytter "pris pr. lys" og fjernbetjenings-info på plads.
   2) Batteri-tilbehør følger antallet af hovedproduktet.
   3) Pakke-beregner (juletræets højde -> antal).
   4) Sørger for at batteri-tilbehør lægges i kurven med det beregnede antal. */
(() => {
  'use strict';
  if (window.dhaPdpExtras) return;
  window.dhaPdpExtras = true;

  const root = () => document.querySelector('product-info[data-section-type="product-page"]');
  const qtyInputs = () => [...document.querySelectorAll('product-info[data-section-type="product-page"] input[name="quantity"]')];
  const mainQty = () => {
    const input = root()?.querySelector('.m-product-form--main input[name="quantity"]') || qtyInputs()[0];
    return Math.max(1, parseInt(input?.value, 10) || 1);
  };
  const lang = (document.documentElement.lang || 'da').split('-')[0];
  const currency = window.Shopify?.currency?.active;
  const money = cents => {
    try {
      if (currency) return new Intl.NumberFormat(lang, { style: 'currency', currency }).format(cents / 100);
    } catch (_) {}
    return (cents / 100).toFixed(2);
  };

  function place() {
    const info = root();
    if (!info) return;
    const per = info.querySelector('[data-dha-move="price"][hidden]');
    const priceBlock = info.querySelector('.main-product__block-price');
    if (per && priceBlock) {
      priceBlock.append(per);
      per.hidden = false;
    }
    const remote = info.querySelector('[data-dha-move="obs"][hidden]');
    if (remote) {
      // Erstat det røde "Virker ikke med fjernbetjening"-badge med en rolig info-linje.
      const obsTag = [...info.querySelectorAll('.main-product__block-custom_liquid .m-product-tag--sale')]
        .find(tag => !tag.closest('a') && !tag.closest('.main-product__block-price'));
      const target = obsTag?.closest('.main-product__block');
      if (target) {
        target.replaceChildren(remote);
      } else {
        (info.querySelector('.dha-product-heading') || info.querySelector('.main-product__block-title'))?.after(remote);
      }
      remote.hidden = false;
    }
  }

  function syncAddons() {
    const n = mainQty();
    document.querySelectorAll('[data-dha-addon][data-dha-per]').forEach(box => {
      const per = parseFloat(box.dataset.dhaPer) || 0;
      const pack = parseInt(box.dataset.dhaPack, 10) || 1;
      const cents = parseInt(box.dataset.dhaCents, 10) || 0;
      const q = Math.max(1, Math.ceil((per * n) / pack));
      box.dataset.quantity = String(q);
      const row = box.closest('.dha-addon');
      if (!row) return;
      const qty = row.querySelector('[data-dha-addon-qty]');
      if (qty) qty.textContent = q;
      const total = row.querySelector('[data-dha-addon-total]');
      if (total && cents) total.textContent = '+ ' + money(cents * q);
      const note = row.querySelector('[data-dha-addon-note]');
      if (note?.dataset.template) note.textContent = note.dataset.template.replace('[n]', q * pack);
    });
    document.querySelectorAll('[data-dha-calc-qty]').forEach(button => {
      button.setAttribute('aria-pressed', String(parseInt(button.dataset.dhaCalcQty, 10) === n));
    });
  }

  function setQuantity(n) {
    qtyInputs().forEach(input => {
      input.value = n;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    syncAddons();
  }

  document.addEventListener('click', event => {
    const calc = event.target.closest('[data-dha-calc-qty]');
    if (calc) {
      event.preventDefault();
      setQuantity(parseInt(calc.dataset.dhaCalcQty, 10) || 1);
      return;
    }
    if (event.target.closest('m-quantity-input, .m-quantity')) setTimeout(syncAddons, 0);
  });
  document.addEventListener('input', event => { if (event.target.matches?.('input[name="quantity"]')) syncAddons(); });
  document.addEventListener('change', event => { if (event.target.matches?.('input[name="quantity"]')) syncAddons(); });

  // Temaet lægger altid tilbehør i kurven med antal 1 (bundle.append(`items[n][quantity]`, '1')).
  // Her udskiftes antallet for batterier med det beregnede antal, lige når temaet bygger forespørgslen.
  // (window.fetch bliver overskrevet af en app, så det sker på FormData-niveau.)
  const nativeAppend = FormData.prototype.append;
  FormData.prototype.append = function (name, value, ...rest) {
    try {
      const match = typeof name === 'string' && name.match(/^items\[(\d+)\]\[quantity\]$/);
      if (match && match[1] !== '0') {
        const id = this.get(`items[${match[1]}][id]`);
        const box = id && document.querySelector(`[data-dha-addon][value="${CSS.escape(String(id))}"]:checked`);
        if (box?.dataset.quantity) value = box.dataset.quantity;
      }
    } catch (_) {}
    return nativeAppend.call(this, name, value, ...rest);
  };

  const start = () => { place(); syncAddons(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  window.addEventListener('load', start, { once: true });
})();
